import { createSlice } from '@reduxjs/toolkit';
import actions from './actions';
import { NAME_REDUCER } from './constants';
import { IState } from '../interfaces/reducer';

const initialState: IState = {
  dataDemo: [],
  dataPlaylists: null,
  playlistsParam: {
    page: 1,
    size: 10,
  },
};

export const Slice = createSlice({
  name: NAME_REDUCER,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(actions.getDemoData.success, (state, { payload }) => {
        state.dataDemo = payload;
      })
      .addCase(actions.getListPlaylists.success, (state, { payload }) => {
        state.dataPlaylists = payload;
      })
      .addCase(actions.setPlaylistsParam, (state, { payload }) => {
        state.playlistsParam = payload;
      });
  },
});

/** TODO:
 * please replace playlist => your feature name
 * ex:
 *      my feature is booking 
 *  name sagas like
 *      channelServiceReducer => bookingServiceReducers
 * 
 * // TODO:
 * Move to rootReducer (src/store/root/reducers.ts) and import your feature reducer
 */
export const playlistUIActions = Slice.actions;

const playlistServiceReducer = Slice.reducer;
export default playlistServiceReducer;